import"./ProductImage.css.ts.vanilla.css";var e="sdvz5o0",o="sdvz5o1";export{e as productImageContainerStyle,o as productImageFigureStyle};
